import styled from 'styled-components';

const LayoutStyle = styled.section`
	--distanceRight: var(--sp4x);
	--contentGap: var(--sp4x);
	--collapseItemDescriptionMTop: var(--sp3x);
	--collapseItemDescriptionGap: var(--sp2x);

	--lineWidth: 2px;
	--activeLineWidth: 4px;
	--activeLineHeight: calc(var(--h6) * var(--lineHeightM));
	--activeLineDistance: var(--sp4x);

	margin-top: var(--pageDistance);

	.text-titles {
		text-align: right;
	}

	.left-inner-block {
		padding-right: var(--distanceRight);
	}

	.first-block {
		display: flex;
		flex-direction: column;
		gap: var(--contentGap);

		padding-right: var(--activeLineDistance);
		border-right: var(--lineWidth) solid var(--gray100);
	}

	.collapse-item-description {
		display: flex;
		flex-direction: column;
		gap: var(--collapseItemDescriptionGap);
		margin-top: var(--collapseItemDescriptionMTop);
	}

	.clickable-all #collapse-item {
		cursor: unset;
	}

	.collapse-item-link {
		.comp-text {
			transition: color var(--trTime) ease-out;
			text-align: right;
		}

		&.active {
			pointer-events: none;
			cursor: default;

			.comp-text {
				color: var(--red1000);
			}
		}
	}

	.bar-item {
		position: relative;

		.comp-text {
			transition: all var(--trTime) ease-out;
			text-align: right;
		}

		&.active {
			pointer-events: none;
			cursor: default;

			.comp-text {
				color: var(--red1000);
				font-weight: 500 !important;
			}

			&::before {
				content: '';
				position: absolute;
				top: 0;
				left: calc(100% + var(--activeLineDistance) - (var(--activeLineWidth) - var(--lineWidth)) / 2);
				width: var(--activeLineWidth);
				height: var(--activeLineHeight);
				background-color: var(--red1000);
			}
		}
	}

	.wrapper-title-button {
		display: flex;
		align-items: center;
		justify-content: flex-end;
		gap: var(--gutter);
		cursor: pointer;

		position: relative;

		.comp-text {
			transition: all var(--trTime) ease-out;
		}

		svg {
			width: var(--p1);
			height: var(--p1);
			transition: all var(--trTime) ease-out;

			path {
				fill: var(--black800);
				transition: fill var(--trTime) ease-out;
			}

			&.active {
				opacity: 1;
			}
		}

		&.active {
			.comp-text {
				font-weight: 500 !important;
				color: var(--red1000);
			}

			svg {
				path {
					fill: var(--black1000);
				}
			}

			&::before {
				content: '';
				position: absolute;
				top: 0;
				left: calc(100% + var(--activeLineDistance) - (var(--activeLineWidth) - var(--lineWidth)) / 2);
				width: var(--activeLineWidth);
				height: var(--activeLineHeight);
				background-color: var(--red1000);
			}
		}
	}

	#collapse-item {
		&.active {
			svg {
				transform: rotate(180deg);
			}
		}
	}

	@media (pointer: fine) {
		@media (hover: hover) {
			.bar-item {
				&:not(.active):hover {
					.comp-text {
						color: var(--black1000);
					}
				}
			}

			.wrapper-title-button {
				&:not(.active):hover {
					.comp-text {
						color: var(--black1000);
					}

					svg {
						path {
							fill: var(--black1000);
						}
					}
				}
			}

			.collapse-item-link {
				&:not(.active):hover {
					.comp-text {
						color: var(--red1000);
					}
				}
			}
		}
	}

	//! 1920
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--distanceRight: var(--sp4x);
		--contentGap: var(--sp4x);
		--collapseItemDescriptionMTop: var(--sp3x);
		--collapseItemDescriptionGap: var(--sp2x);
	}

	//! 1536
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--distanceRight: var(--sp3x);
		--contentGap: var(--sp3x);
		--collapseItemDescriptionMTop: var(--sp2x);
		--collapseItemDescriptionGap: var(--sp1-5x);
	}

	//! 1366
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--distanceRight: var(--sp3x);
		--contentGap: var(--sp3x);
		--collapseItemDescriptionMTop: var(--sp2x);
		--collapseItemDescriptionGap: var(--sp1x);
	}

	//! 1280
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--distanceRight: var(--sp2x);
		--contentGap: var(--sp3x);
		--collapseItemDescriptionMTop: var(--sp2x);
		--collapseItemDescriptionGap: var(--sp1x);
	}

	//! 1024
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--distanceRight: var(--sp2x);
		--contentGap: var(--sp2-5x);
		--collapseItemDescriptionMTop: var(--sp1-5x);
		--collapseItemDescriptionGap: var(--sp1x);
	}

	//! 768
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
		--distanceRight: 0px;
		--contentGap: var(--sp2x);
		--collapseItemDescriptionMTop: var(--sp2x);
		--collapseItemDescriptionGap: var(--sp1x);

		.right-block {
			margin-top: var(--sp4x);
		}

		.collapse-item-link {
			width: fit-content;

			.comp-text {
				text-align: left;
			}
		}

		.bar-item {
			.comp-text {
				text-align: left;
			}
		}

		.wrapper-title-button {
			justify-content: space-between;
		}

		.content {
			display: grid;
			grid-template-columns: 5fr 7fr;
		}
	}

	//! Mobile
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--distanceRight: 0px;
		--contentGap: var(--sp2x);
		--collapseItemDescriptionMTop: var(--sp1x);
		--collapseItemDescriptionGap: var(--sp1x);

		.content {
			grid-template-columns: 1fr;
		}
	}
`;

export default LayoutStyle;
